<template>
    <div class='component-page'>
        <div class="filter-area">
            <Row style='text-align: center;' class='add_search'>
               
               
            </Row>
        </div>
        <!--下拉搜索位置-->
        <div class="edittable-table-height-con">
            <Row class='search-select'>
                <Col span="8">
                    <span>时间：</span>
                    <Date-picker type="date" placeholder="选择日期" v-model='start_time' style="width: 130px;display:inline-block" @on-change='changStarttime'></Date-picker>
                    <span style="margin: 0 10px;">至</span>
                    <Date-picker type="date" placeholder="选择日期" v-model='end_time' style="width: 130px;display:inline-block" @on-change='changEndtime'></Date-picker>
                </Col>
            </Row>
            <Table stripe border :columns="editIncellColumns" :data="editIncellData"></Table>
            <div style="margin: 20px 0 10px 0 ;overflow: hidden;">
                <Page style='float: right'  size="small" :total="total_count" :page-size="formItem.page_size" :current="formItem.page" @on-change="changePage" />
            </div>
        </div>
         <!--提醒弹层-->
        <Modal v-model="remindModal" width="440" class='remind'>
            <div class='remindContent'>
                {{remindContent}}
            </div>
            <div slot="footer">
                <Button type='primary' ghost shape="circle" @click='cancelRemain'>取消</Button>
                <Button type="primary" shape="circle" @click="primaryRemind">确定</Button>
            </div>
        </Modal>
    </div>
</template>

<style lang="css">
    @import "../common.css";
</style>
<script>
    import {
        fetchTableList,
        setStatus
    } from '@/api/consultEnroll'

    export default {
        name: 'user-components',
        data () {
            return {
                total_count: 0, //列表总条数
                formItem:{
                    page: 1, //列表当前页数
                    page_size: 10,
                    start_time: '',
                    end_time: '',
                    phone:'',
                },
                start_time: '',
                end_time: '',
                id:'',
                remindContent:'',//提醒内容
                remindModal:false,//提醒弹层状态
                editIncellColumns: [
                    {
                        title: '序号',
                        align: 'center',
                        type: 'index',
                        width: 80,
                    },
                    {
                        title: '报名类型',
                        align: 'center',
                        key: 'type',
                        render: (h, params) => {
                            if(params.row.type==1){
                                return h('div', '全网挑战赛')
                            }else if(params.row.type==2){
                                return h('div', '游学')

                            }else if(params.row.type==3){
                                return h('div', '音乐汇')

                            }else{
                                return h('div', '课程详情报名')

                            }
                        }
                    },
                    {
                        title: '真实姓名',
                        align: 'center',
                        key: 'realname',
                    },
                    {
                        title: '手机号',
                        align: 'center',
                        key: 'phone',
                    },
                    {
                        title: '是否联系',
                        align: 'center',
                        key: 'is_contact',
                        render: (h, params) => {
                            if(params.row.is_contact==1){
                                return h('div', '联系')
                            }else{
                                return h('div', '未联系')
                            }
                        }
                    },
                    {
                        title: '咨询时间',
                        align: 'center',
                        key: 'create_at',
                        width:150,

                    },
                    {
                        title: '咨询内容',
                        align: 'center',
                        key: 'content',
                        tooltip:true,
                      
                    },
                    
                     {
                        title: '操作',
                        align: 'center',
                        key: 'action',
                        width: 120,
                        render: (h, params) => {
                            if(params.row.is_contact==0){
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                            ghost: true
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.changeStatus(params.row.id,'确定联系该用户吗？')
                                            }
                                        }
                                    }, '联系'),
                                ])
                            }else{
                                return h('div', '无操作')
                            }
                           
                        }
                    }
                
                ],//列表
                editIncellData: [],//列表数据
            };
        },
        methods: {
            //获取列表数据
            getData () {
                this.$Loading.start();
                fetchTableList(this.formItem).then(res => {
                    res=res.data;
                    this.$Loading.finish();
                    if(res.code == 200){
                        this.editIncellData = res.data.list;
                        this.total_count = parseInt(res.data.total_count);
                    }else if(res.code == 14001){
                        this.$Message.error(res.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    }else{
                        this.$Message.error(res.msg);
                    }
                })
            },
         
            // 改变状态
            changeStatus(id,info){
                console.log(id);
                this.id = id;
                this.remindContent = info;
                this.remindModal = true; 
            },
            //提醒弹出层的确定事件
            primaryRemind(){
                    setStatus({
                        id:this.id
                    }).then(res => {
                        res=res.data;
                        if(res.code==200){
                            this.getData();
                            this.remindModal=false;
                        }else if(res.code == 14001){
                            this.$Message.error(res.msg);
                            this.$store.dispatch('handleLogOut').then(res => {
                                this.$store.commit('clearOpenedSubmenu')
                                this.$router.push({
                                    name: 'login'
                                })
                            })
                        }else{
                            this.$Message.error(res.msg);
                        }
                    })
                
                
            },
             // 改变开始时间
            changStarttime(time) {
                if (time == '') {
                    this.formItem.start_time = '';
                } else {
                    this.formItem.start_time = new Date(time).getTime() / 1000 - 28800;
                }
                this.formItem.page = 1;
                this.getData();
            },
            // 改变结束时间
            changEndtime(time) {
                if (time == '') {
                    this.formItem.end_time = '';
                } else {
                    this.formItem.end_time = new Date(time).getTime() / 1000 + 57600;
                }
                this.formItem.page = 1;
                this.getData();
            },
            // 取消关闭弹层
            cancel(){
                this.addModel=false;
                this.detailsModal=false;
            },
            // 关闭提醒弹出
            cancelRemain(){
                this.remindModal = false; 
            },
            //搜索框搜索
            handleSearch () {
                this.formItem.page = 1;
                this.getData();
            },
            //改变当前页码
            changePage (row) {
                this.formItem.page = row;
                this.getData();
            },
            
        },
        created () {
            this.getData();
        }
    };
</script>
